"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylableEditor = void 0;
var tslib_1 = require("tslib");
var editor_edit_session_1 = require("./editor-edit-session");
var stylable_change_selectors_1 = require("./stylable-change-selectors");
var stylable_driver_1 = require("./stylable-driver");
var stylable_site_vars_1 = require("./stylable-site-vars");
var createVariantKey = function (path, variant) { return "".concat(path, "_").concat(variant); };
var StylableEditor = /** @class */ (function () {
    function StylableEditor(config, siteStylesheetPath, experiments) {
        var _this = this;
        this.experiments = experiments;
        this.stylesheetPath = '';
        this.selectionCache = {};
        this.getMinimalCss = function (css) { return css; };
        this.externalComponentsConfig = {};
        this.variantConfigOverrides = {};
        this.selection = [];
        this.siteStylesheetPath = siteStylesheetPath;
        this.config = config;
        this.experiments = experiments;
        this.stylableDriver = new stylable_driver_1.StylableDriver(undefined, config.packages, stylable_driver_1.USAGE_MAPPING_ALLOW_ALL, this.experiments);
        this.writeFilesWithNamespace(this.config.fs);
        this.stylableDriver.registerBuildHook(function () {
            _this.selection.forEach(function (editSession) {
                editSession.updateComputed();
            });
        });
    }
    StylableEditor.prototype.getSelection = function (index) {
        return this.selection[index] || null;
    };
    StylableEditor.prototype.getComponentConfig = function (id) {
        return this.externalComponentsConfig[id] || this.config.components[id] || null;
    };
    StylableEditor.prototype.setComponentExternalConfig = function (id, config) {
        this.externalComponentsConfig[id] = config;
    };
    StylableEditor.prototype.setVariantConfigOverrides = function (path, variant, config) {
        var variantKey = createVariantKey(path, variant);
        delete this.selectionCache[variantKey];
        this.variantConfigOverrides[variantKey] = config;
    };
    StylableEditor.prototype.write = function (path, content) {
        var _a;
        this.writeFilesWithNamespace((_a = {}, _a[path] = { content: content, metadata: { namespace: '' } }, _a));
    };
    StylableEditor.prototype.writeFilesWithNamespace = function (files) {
        var _this = this;
        Object.keys(files).forEach(function (filepath) {
            _this.stylableDriver.writeFile(filepath, files[filepath].content);
            var meta = _this.stylableDriver.stylable.process(filepath);
            meta.namespace = files[filepath].metadata.namespace || meta.namespace;
        });
    };
    // TODO: Deprecate
    StylableEditor.prototype.open = function (path, id, variant, presetPaths, scope, onQuickChange, onRevertQuickChange, onStylesheetCommit) {
        var _a;
        this.stylesheetPath = path;
        this.presetPaths = presetPaths;
        this.stylableDriver.setEntries([this.stylesheetPath]);
        this.stylableDriver.setScope(scope);
        this.select({ path: path, id: id, variant: variant, onQuickChange: onQuickChange, onRevertQuickChange: onRevertQuickChange });
        (_a = this.getSelection(0)) === null || _a === void 0 ? void 0 : _a.changeDriver.setOnStylesheetCommit(onStylesheetCommit);
    };
    StylableEditor.prototype.load = function (options) {
        var path = options.path, presetPaths = options.presetPaths, scope = options.scope;
        this.stylesheetPath = path;
        this.presetPaths = presetPaths;
        this.stylableDriver.setEntries([this.stylesheetPath]);
        this.stylableDriver.setScope(scope);
        this.select(options);
    };
    StylableEditor.prototype.select = function (options) {
        var e_1, _a;
        this.selection.length = 0;
        var selection = this.createSelection(options);
        this.selection.push(selection);
        if (this.stylableDriver.selectionHooks.length) {
            try {
                for (var _b = tslib_1.__values(this.stylableDriver.selectionHooks), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var selectionHook = _c.value;
                    selectionHook(selection);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    StylableEditor.prototype.createSelection = function (options) {
        var path = options.path, id = options.id, variant = options.variant, onQuickChange = options.onQuickChange, onRevertQuickChange = options.onRevertQuickChange, inputPaths = options.inputPaths;
        var cacheKey = createVariantKey(path, variant);
        if (!this.selectionCache[cacheKey]) {
            this.selectionCache[cacheKey] = new editor_edit_session_1.ComponentEditSession(this.siteStylesheetPath, this.stylesheetPath, variant, this.getVariantConfigOverrides(path, id, variant), this.stylableDriver, new stylable_change_selectors_1.StylableChangeSelectors(onQuickChange, onRevertQuickChange), this.presetPaths, inputPaths);
        }
        return this.selectionCache[cacheKey];
    };
    StylableEditor.prototype.registerExtensions = function (extensions) {
        var inlineModules = extensions.inlineModules, transformationPlugins = extensions.transformationPlugins, getMinimalCss = extensions.getMinimalCss;
        if (inlineModules) {
            this.stylableDriver.registerJsModules(inlineModules); // register mixins and formatters
        }
        if (transformationPlugins) {
            this.stylableDriver.registerTransformationPlugins(transformationPlugins);
        }
        if (getMinimalCss) {
            this.getMinimalCss = getMinimalCss;
        }
    };
    StylableEditor.prototype.getStylable = function () {
        return this.stylableDriver.stylable;
    };
    StylableEditor.prototype.getEditableComponents = function () {
        return Object.keys(this.config.components);
    };
    StylableEditor.prototype.createSiteVarsDriver = function (sheet) {
        return new stylable_site_vars_1.StylableSiteVars(sheet);
    };
    StylableEditor.prototype.getVariantConfigOverrides = function (path, id, variant) {
        return immutableOverride(this.getComponentConfig(id), this.variantConfigOverrides[createVariantKey(path, variant)] || {});
    };
    return StylableEditor;
}());
exports.StylableEditor = StylableEditor;
function immutableOverride(objA, objB) {
    var e_2, _a;
    var newObj = tslib_1.__assign({}, objA);
    try {
        for (var _b = tslib_1.__values(Object.entries(objB)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = tslib_1.__read(_c.value, 2), key = _d[0], value = _d[1];
            if (Array.isArray(value)) {
                throw new Error('Array override is not supported');
            }
            if (value && typeof value === 'object') {
                newObj[key] = immutableOverride(objA[key], value);
            }
            else {
                newObj[key] = value;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return newObj;
}
//# sourceMappingURL=stylable-editor.js.map